import React from "react";

import type { Image } from "./types";
import SearchIcon from "../../icons/Search";
import ListIcon from "../../icons/List";
import { geocode, getServiceArea } from "../../utils/geo";
import PlaceAutocomplete from "../Search/PlaceAutocomplete";
import { ServiceLocale } from "../types";

interface Props {
  title: string;
  description: string;
  heroImage: Image;
  serviceLocale: ServiceLocale;
}

function Hero({ title, description, heroImage, serviceLocale }) {
  const [locationValue, setLocationValue] = React.useState(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get('location') || "";
  });
  const [locationCoords, setLocationCoords] = React.useState<{ lat: number; lng: number } | null>(null);

  const handleSearch = async (e) => {
    e.preventDefault();

    if (locationCoords?.lat && locationCoords?.lng) {
      const { lat, lng } = locationCoords;
      window.document.location.href = `?location=${encodeURI(locationValue)}&lat=${lat}&lng=${lng}`;
      return;
    }

    try {
      const results = await geocode(locationValue, { serviceLocale });
      const position = results[0]?.geometry.location;
      const lat = position?.lat();
      const lng = position?.lng();
      if (lat && lng) {
        const serviceArea = getServiceArea(results);
        window.document.location.href = `?location=${encodeURI(locationValue)}&lat=${lat}&lng=${lng}&service_area=${serviceArea ? serviceArea.toLowerCase() : ''}`;
      } else {
        window.document.location.href = `?location=${encodeURI(locationValue)}`;
      }
    } catch (_status) {
      window.document.location.href = `?location=${encodeURI(locationValue)}`;
    }
  };

  return (
    <header>
      <div className="hero">
        <div>
          <div>
            <h1 className="topic-page-title">{title}</h1>
            <p className="topic-page-description">{description}</p>
          </div>
        </div>
        <img {...heroImage} />
      </div>
      <div className="header-floor">
        <form onSubmit={handleSearch} autoComplete='off'>
          <label>My Location</label>
          <div>
            <PlaceAutocomplete
              value={locationValue}
              onChange={(val) => { setLocationValue(val); setLocationCoords(null); }}
              onPlaceSelect={(val, coords) => { setLocationValue(val); setLocationCoords(coords); }}
              placeholder="Search address, city or zip"
            />
            <button type="submit">
              <SearchIcon />
            </button>
          </div>
        </form>
        <a href="/my211/resource-lists" target="_blank" rel="noreferrer">
          <ListIcon /> My Resource Lists
        </a>
      </div>
    </header>
  );
}

export default Hero;
